<template>
  <div class="pie-chart">
    <v-row justify="center">
      <v-col cols="auto">
        <v-chip class="mr-2" @click="setCategroy(cate)" color="primary" v-for="cate in dataCategories" :key="cate">{{ cate }}</v-chip>
      </v-col>
    </v-row>
    <v-responsive :aspect-ratio="1/1">
      <base-chart :option="option" ref="chart"></base-chart>
    </v-responsive>
  </div>
</template>

<script>
import { DEFAULT_PALLETE } from '@/libs/configs/chart'
import BaseChart from '@/components/Charts/Base'

export default {
  components: { BaseChart },
  props: {
    datasets: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      targetCategroy: null
    }
  },
  watch: {
    datasets () {
      this.init()
    }
  },
  computed: {
    option () {
      const option = {
        color: DEFAULT_PALLETE,
        title: {
          text: this.targetCategroy,
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.dataMonth
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.datasetsForPie,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }

      return option
    },
    datasetsForPie () {
      return this.datasets.map(data => ({ value: data[this.targetCategroy], name: data.month }))
    },
    dataMonth () {
      return this.datasets.map(data => data.month)
    },
    dataCategories () {
      return Object.keys(this.datasets[0]).filter(key => key !== 'month')
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.setCategroy(this.dataCategories[0])
    },
    setCategroy (value) {
      this.targetCategroy = value
    }
  }
}
</script>
